import { render, staticRenderFns } from "./home_project1.vue?vue&type=template&id=064b04a1&scoped=true&"
import script from "./home_project1.vue?vue&type=script&lang=js&"
export * from "./home_project1.vue?vue&type=script&lang=js&"
import style0 from "./home_project1.vue?vue&type=style&index=0&id=064b04a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b04a1",
  null
  
)

export default component.exports